import { render, staticRenderFns } from "./Tabbar.vue?vue&type=template&id=5faf1f5a&scoped=true"
import script from "./Tabbar.vue?vue&type=script&lang=js"
export * from "./Tabbar.vue?vue&type=script&lang=js"
import style0 from "./Tabbar.vue?vue&type=style&index=0&id=5faf1f5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5faf1f5a",
  null
  
)

export default component.exports